<template lang="pug">
	div(v-if="$store.state.bestPlansExitModalContent && ($store.state.bestPlansExitModalContent.title || $store.state.bestPlansExitModalContent.collegeBackerExit || $store.state.bestPlansExitModalContent.upromiseExit || $store.state.bestPlansExitModalContent.upromiseExitWithText || $store.state.bestPlansExitModalContent.uNestExitWithText)")
		b-modal.full-screen-modal(id="exit-modal" :class="{'tall-modal-layout' : $store.state.bestPlansExitModalContent.exitWithTwoImages, 'collegebacker-layout' : $store.state.bestPlansExitModalContent.collegeBackerExit, 'upromise-layout' : $store.state.bestPlansExitModalContent.upromiseExit, 'wide-modal-layout' : $store.state.bestPlansExitModalContent.exitWithThreeImages}" :hide-header="true" centered no-fade :hide-footer="true" ref="exitModal" no-close-on-backdrop=true @shown="trackShown" :no-close-on-esc="true")
			div(v-if="$store.state.bestPlansExitModalContent.collegeBackerExit")
				.close(@click="hideModal()")
					| X
				a.simple(href="https://collegebacker.com/origin/sfc-exitfamily" @click="trackClick()" target="_blank")
					b-img-lazy.merril-interstitial(:src="`${$store.state.config.s3ResourceHost}/images/sfc-collegebacker-interstitial.jpg`")

			div(v-else-if="$store.state.bestPlansExitModalContent.upromiseExit")
				.close(@click="hideModal()")
					| X
				a.simple(:href="`${$store.state.bestPlansExitModalContent.firstImageLink}`" @click="trackClick()" target="_blank")
					b-img-lazy.merril-interstitial(:src="`${$store.state.config.s3ResourceHost}/images/${$store.state.bestPlansExitModalContent.firstImageFile}`")

			div(v-else-if="$store.state.bestPlansExitModalContent.upromiseExitWithText")
				h1.upromise-title
					| Upromise helps you save for college
				a.simple(:href="`${$store.state.bestPlansExitModalContent.firstImageLink}`" @click="trackClick()" target="_blank")
					b-img-lazy.merril-interstitial.v3(:src="`${$store.state.config.s3ResourceHost}/images/${$store.state.bestPlansExitModalContent.firstImageFile}`")
				.text-white.underline.cursor-pointer.mt-3.text-center(@click="hideModal()")
					| No thanks

			div(v-else-if="$store.state.bestPlansExitModalContent.uNestExitWithText")
				h1.upromise-title
					| A simple way to save for your kids' education
				a.simple(:href="`${$store.state.bestPlansExitModalContent.firstImageLink}`" @click="trackClick()" target="_blank")
					b-img-lazy.merril-interstitial.v3(:src="`${$store.state.config.s3ResourceHost}/images/${$store.state.bestPlansExitModalContent.firstImageFile}`")
				.text-white.underline.cursor-pointer.mt-3.text-center(@click="hideModal()")
					| No thanks

			div(v-else-if="$store.state.bestPlansExitModalContent.emailCapture")
				b-row
					b-col(md="12")
						.text-right.text-white.text-uppercase.underline.cursor-pointer(@click="hideModal(emailCaptureScreen == 1)")
							| close

					b-col(offset-md="5" md="7" v-show="emailCaptureScreen == 1")
						.text-white.mb-2
							| {{$store.state.bestPlansExitModalContent.copy1}}
					b-col(md="5" v-show="emailCaptureScreen == 1")
						b-img-lazy.img-fluid(:src="`${$store.state.config.s3ResourceHost}/images/${$store.state.bestPlansExitModalContent.firstImageFile}`" alt="Download Family Guide")
					b-col(md="7" v-show="emailCaptureScreen == 1")
						h1.text-white.font-large.text-left
							| {{$store.state.bestPlansExitModalContent.title}}
						b-row
							b-col(md="6")
								sfc-select-wrapper(:flat="true" :error="typeOfUserError" :errorMessage="typeOfUserErrorMessage")
									select.text-white(v-model="typeOfUser" @change="validateForm()")
										option(value="" hidden disabled) I am a ...
										option(value="parent") Parent
										option(value="grandparent") Grandparent
										option(value="advisor") Financial Advisor
										option(value="other") Other
							b-col(md="6")
								sfc-select-wrapper(:flat="true" :error="stateOfResidenceError" :errorMessage="stateOfResidenceErrorMessage")
									select.text-white(v-model="stateOfResidence" @change="validateForm()")
										option(value="" hidden disabled) State of residence
										option(v-for="state of states" :value="state.id")
											| {{state.name}}
							b-col(md="12")
								sfc-input.text-white(v-model="email" :error="emailError" :errorMessage="emailErrorMessage" placeholder="Your email address" @input="validateForm()")
							b-col.text-left(md="12")
								a.btn.sfc-yellow.btn-small.mt-5(:href="`${$store.state.config.familyGuideUrl}`" @click="submitDownloadGuide($event)" download="family_guide_to_college_savings.pdf" target="_blank")
									| {{$store.state.bestPlansExitModalContent.buttonCopy}}
					b-col.modal-text-white.modal-text-align-center(md="12" v-show="emailCaptureScreen == 2")
						b-row
							b-col(md="12")
								h1 Downloading ...
								br
						b-row.modal-paragraph
							b-col(md="12")
								a.modal-text-white.modal-text-underline(:href="`${$store.state.config.familyGuideUrl}`" download="family_guide_to_college_savings.pdf" target="_blank") Click here
								| &nbsp;if your download did not automatically start.
								br
								br
								br
								br
						b-row.modal-paragraph.justify-content-md-center
							b-col(md="9")
								| Looking for the&nbsp;
								a.modal-text-white.modal-text-underline(href="/intro-to-529s/which-is-the-best-529-plan-available" @click="trackSecondaryClick()") best 529 plans of {{currentYear}}
								| ? We analyze more than 100 plans from across the country each quarter and select only the best.
						b-row.modal-paragraph-small
							b-col.modal-text-underline(md="12")
								br
								br
								br
								.text-white.underline.cursor-pointer(@click="hideModal(false)")
									| No thanks
			div(v-else-if="$store.state.bestPlansExitModalContent.newsletter")
				b-row
					b-col(md="12")
						.text-right.text-white.text-uppercase.underline.cursor-pointer(@click="hideModal(false)")
							| close
					b-col.text-center(md="8" offset-md="2" sm="12" offset-sm="0")
						h1.text-white.font-xlarge.text-center
							| {{$store.state.bestPlansExitModalContent.title}}
					b-col.text-center(md="8" offset-md="2" sm="12" offset-sm="0")
						.text-white.mb-4.mt-4(style="font-size: body-font-size-lg-plus")
							| {{$store.state.bestPlansExitModalContent.copy1}}
				b-row
					b-col.email-capture-newsletter(md="6" offset-md="3" sm="12" offset-sm="0")
						sfc-simple-email-capture(v-model="email" :button-text="$store.state.bestPlansExitModalContent.buttonCopy" success-message-title="Thank you!" success-message="You have been successfully subscribed to our email list." :input-error-message="emailErrorMessage" @input="emailErrorMessage = ''" :email-capture-success="emailSuccess" @success="submitEmail" :show-state="true" :show-type-of-user="true")
				b-row(v-if="!emailSuccess")
					b-col(md="12")
						.text-white.underline.cursor-pointer.mt-3.text-center(@click="hideModal(false)")
							| {{$store.state.bestPlansExitModalContent.exitCopy}}
				b-row(v-else)
					b-col(md="12")
						.text-white.underline.cursor-pointer.mt-3.text-center(@click="hideModal(false)")
							| Close

			div(v-else)
				h1
					| {{$store.state.bestPlansExitModalContent.title}}
				p {{$store.state.bestPlansExitModalContent.copy1}}
				div(v-if="$store.state.bestPlansExitModalContent.exitWithImage")
					a.simple(:href="`/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=${$store.state.bestPlansExitModalContent.firstImagePlanId}&click_source=exit_intent_modal`" @click="trackClick()")
						b-img-lazy.merril-interstitial(:src="`${$store.state.config.s3ResourceHost}/images/${$store.state.bestPlansExitModalContent.firstImageFile}`")
					a.simple.more-529-plans(href="/intro-to-529s/which-is-the-best-529-plan-available" @click="trackSecondaryClick()") Show me more great plans
					div.text-center
						a.simple.mt-0(@click="hideModal()") {{$store.state.bestPlansExitModalContent.exitCopy}}
				div(v-else-if="$store.state.bestPlansExitModalContent.exitWithStateImage")
					a.simple(:href="$store.state.bestPlansExitModalContent.enrollNowUrl" @click="trackClick()")
						b-img-lazy.merril-interstitial(:src="`${$store.state.config.s3ResourceHost}/images/${$store.state.bestPlansExitModalContent.firstImageFile}`")
					a.simple.more-529-plans(:href="$store.state.bestPlansExitModalContent.statePageUrl" @click="trackSecondaryClick()") {{$store.state.bestPlansExitModalContent.secondaryCopy}}
					div.text-center
						a.simple.mt-0(@click="hideModal()") {{$store.state.bestPlansExitModalContent.exitCopy}}
				div(v-else-if="$store.state.bestPlansExitModalContent.exitWithTwoImages")
					a.simple.mt-0(:href="`/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=${$store.state.bestPlansExitModalContent.firstImagePlanId}&click_source=exit_intent_modal`" @click="trackClick()")
						b-img-lazy.merril-interstitial(:src="`${$store.state.config.s3ResourceHost}/images/${$store.state.bestPlansExitModalContent.firstImageFile}`")
					a.simple.mt-0(:href="`/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=${$store.state.bestPlansExitModalContent.secondImagePlanId}&click_source=exit_intent_modal`" @click="trackClick()")
						b-img-lazy.merril-interstitial(:src="`${$store.state.config.s3ResourceHost}/images/${$store.state.bestPlansExitModalContent.secondImageFile}`")
					a.simple.more-529-plans(href="/intro-to-529s/which-is-the-best-529-plan-available" @click="trackSecondaryClick()") Show me more great plans
					div.text-center
						a.simple.mt-0(@click="hideModal()") {{$store.state.bestPlansExitModalContent.exitCopy}}
				div(v-else-if="$store.state.bestPlansExitModalContent.exitWithThreeImages")
					.row
						b-col(md="4")
							a.simple.mt-0(:href="`/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=${$store.state.bestPlansExitModalContent.firstImagePlanId}&click_source=exit_intent_modal`" @click="trackClick()")
								b-img-lazy.merril-interstitial(:src="`${$store.state.config.s3ResourceHost}/images/${$store.state.bestPlansExitModalContent.firstImageFile}`")
						b-col(md="4")
							a.simple.mt-0(:href="`/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=${$store.state.bestPlansExitModalContent.secondImagePlanId}&click_source=exit_intent_modal`" @click="trackClick()")
								b-img-lazy.merril-interstitial(:src="`${$store.state.config.s3ResourceHost}/images/${$store.state.bestPlansExitModalContent.secondImageFile}`")
						b-col(md="4")
							a.simple.mt-0(:href="`/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=${$store.state.bestPlansExitModalContent.thirdImagePlanId}&click_source=exit_intent_modal`" @click="trackClick()")
								b-img-lazy.merril-interstitial(:src="`${$store.state.config.s3ResourceHost}/images/${$store.state.bestPlansExitModalContent.thirdImageFile}`")
					.row
						b-col(md="12")
							a.simple.more-529-plans(href="/intro-to-529s/which-is-the-best-529-plan-available" @click="trackSecondaryClick()") Show me more great plans
							div.text-center
								a.simple.mt-0(@click="hideModal()") {{$store.state.bestPlansExitModalContent.exitCopy}}

				div(v-else-if="$store.state.bestPlansExitModalContent.exitWithTwoImagesSideBySide")
					.row
						b-col(md="6")
							a.simple.mt-0(:href="`/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=${$store.state.bestPlansExitModalContent.firstImagePlanId}&click_source=exit_intent_modal`" @click="trackClick()")
								b-img-lazy.merril-interstitial(:src="`${$store.state.config.s3ResourceHost}/images/${$store.state.bestPlansExitModalContent.firstImageFile}`")
						b-col(md="6")
							a.simple.mt-0(:href="`/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=${$store.state.bestPlansExitModalContent.secondImagePlanId}&click_source=exit_intent_modal`" @click="trackClick()")
								b-img-lazy.merril-interstitial(:src="`${$store.state.config.s3ResourceHost}/images/${$store.state.bestPlansExitModalContent.secondImageFile}`")
					.row
						b-col(md="12")
							a.simple.more-529-plans(href="/intro-to-529s/which-is-the-best-529-plan-available" @click="trackSecondaryClick()") Show me more great plans
							div.text-center
								a.simple.mt-0(@click="hideModal()") {{$store.state.bestPlansExitModalContent.exitCopy}}

				div(v-else)
					a.btn.sfc-yellow(href="/intro-to-529s/which-is-the-best-529-plan-available" @click="trackClick()") {{$store.state.bestPlansExitModalContent.buttonCopy}}
					p
						a.simple(@click="hideModal()") {{$store.state.bestPlansExitModalContent.exitCopy}}
</template>

<style lang="stylus">
	@import '~assets/css/variables.styl'

	#exit-modal
		z-index: 5000

	.email-capture-newsletter
		span.error
			text-align: left!important
			display: block
		h4
			text-align: center
			color: sfc-yellow
			margin-bottom :15px
			margin-top: 30px
		input
			color: #fff!important
		a.btn
			font-size: body-font-size-md!important
			padding: 10px 25px!important
			margin: 0 auto
			margin-top: 30px
			border: 1px solid sfc-yellow-border !important
			background: sfc-yellow !important
			color: #fff !important
			&:hover
				background: sfc-yellow-border !important
	.full-screen-modal
		&.tall-modal-layout
			.modal-body
				padding-top: 0
		.v3
			border: 1px solid #000
			box-shadow-modal()
		.merril-interstitial
			width: 100%
			padding: 0
		.modal-backdrop
			background-color: #0d4378
			&.show
				opacity: 0.9
		&.collegebacker-layout
			.modal-backdrop
				background-color: #eefaf8
				&.show
					opacity: 0.9
		&.upromise-layout
			.modal-backdrop
				background-color: body-font-color
				&.show
					opacity: 0.7
			.close
				color: #fff
		.modal-dialog
			width: 75%
			max-width: 800px
			margin: 0 auto
			.modal-content
				background: transparent
				border: 0px solid transparent
				h1
				p
					text-align: center
					color: #fff
				h1
					font-size: body-font-size-xl
					&.upromise-title
						margin-bottom: 20px
						font-size: body-font-size-xl
				p
					font-size: body-font-size-lg-plus
					&.simple
						text-align: center
				a.simple
					color: #fff
					display: inline-block
					font-size: body-font-size-lg
					margin-top: 15px
					cursor: pointer
					&.more-529-plans
						position: relative
						right: 20px
						display: block
						text-align: right
						top: -30px
						font-size: body-font-size-md
						@media (max-width: 576px)
							top: -10px
				a.btn
					text-transform: uppercase
					text-align: center
					display: table
					margin: 0 auto
					font-size: body-font-size-lg-plus
					padding: 15px 30px
					margin-top: 60px
					border: 2px solid #654003!important
					box-shadow: 0 10px 26px 0 rgba(17, 58, 108, 0.6)
					&.btn-small
						font-size: body-font-size-md
						padding 10px 25px
						margin 0
		&.wide-modal-layout
			.modal-dialog
				max-width: 1000px
				.col-md-4
					padding: 0

		.text-white
			color #fff
			input[type="text"]
				color #fff
		select.text-white
			color #fff !important
		.tb
			input[type="text"]
				background transparent
			span.arrow-down
				border-top: 7px solid white !important
		.font-large
			font-size: body-font-size-xl !important
		.font-xlarge
			font-size 34px !important
		.cursor-pointer
			cursor pointer

		.modal-text-white
			color: #fff;

		.modal-paragraph
			font-size: body-font-size-md

		.modal-paragraph-small
			font-size: body-font-size-xs

		.modal-text-underline
			text-decoration: underline

		.modal-text-align-center
			text-align: center


</style>
<script>
	import SfcTrackingService from "@/lib/sfc-tracking-service"
	import SfcSimpleEmailCapture from "@/common/components/sfc-simple-email-capture.vue"

	export default {
		components: {
			SfcSimpleEmailCapture
		},

		data(){

			let states = [
				{id: 1, name: "Alabama"},
				{id: 2, name: "Alaska"},
				{id: 3, name: "Arizona"},
				{id: 4, name: "Arkansas"},
				{id: 5, name: "California"},
				{id: 6, name: "Colorado"},
				{id: 7, name: "Connecticut"},
				{id: 8, name: "Delaware"},
				{id: 9, name: "District of Columbia"},
				{id: 10, name: "Florida"},
				{id: 11, name: "Georgia"},
				{id: 12, name: "Hawaii"},
				{id: 13, name: "Idaho"},
				{id: 14, name: "Illinois"},
				{id: 15, name: "Indiana"},
				{id: 16, name: "Iowa"},
				{id: 17, name: "Kansas"},
				{id: 18, name: "Kentucky"},
				{id: 19, name: "Louisiana"},
				{id: 20, name: "Maine"},
				{id: 21, name: "Maryland"},
				{id: 22, name: "Massachusetts"},
				{id: 23, name: "Michigan"},
				{id: 24, name: "Minnesota"},
				{id: 25, name: "Mississippi"},
				{id: 26, name: "Missouri"},
				{id: 27, name: "Montana"},
				{id: 28, name: "Nebraska"},
				{id: 29, name: "Nevada"},
				{id: 30, name: "New Hampshire"},
				{id: 31, name: "New Jersey"},
				{id: 32, name: "New Mexico"},
				{id: 33, name: "New York"},
				{id: 34, name: "North Carolina"},
				{id: 35, name: "North Dakota"},
				{id: 36, name: "Ohio"},
				{id: 37, name: "Oklahoma"},
				{id: 38, name: "Oregon"},
				{id: 39, name: "Pennsylvania"},
				{id: 40, name: "Rhode Island"},
				{id: 41, name: "South Carolina"},
				{id: 42, name: "South Dakota"},
				{id: 43, name: "Tennessee"},
				{id: 44, name: "Texas"},
				{id: 45, name: "Utah"},
				{id: 46, name: "Vermont"},
				{id: 47, name: "Virginia"},
				{id: 48, name: "Washington"},
				{id: 49, name: "West Virginia"},
				{id: 50, name: "Wisconsin"},
				{id: 51, name: "Wyoming"}
			]

			return {
				states,
				currentYear: (new Date()).getFullYear(),
				email: "",
				stateOfResidence: "",
				typeOfUser: "",
				stateOfResidenceErrorMessage: "",
				stateOfResidenceError: false,
				emailErrorMessage: "",
				emailError: false,
				emailSuccess: false,
				typeOfUserErrorMessage: "",
				typeOfUserError: false,
				emailCaptureScreen: 1
			}
		},

		methods:{
			hideModal(track = true) {
				if(track)
					this.trackDismiss()
				this.$refs.exitModal.hide()
				document.body.classList.remove('blurbody')

			},

			trackShown(){
				document.body.classList.add('blurbody')
				SfcTrackingService.trackAnalyticsAction('Exit Intent Modal', 'Show', this.$store.state.bestPlansExitModalContent.version)
			},

			trackClick(){
				SfcTrackingService.trackAnalyticsAction('Exit Intent Modal', 'Click', this.$store.state.bestPlansExitModalContent.version, 0)
			},

			trackDismiss(){
				SfcTrackingService.trackAnalyticsAction('Exit Intent Modal', 'Dismiss', this.$store.state.bestPlansExitModalContent.version)
			},

			trackSecondaryClick(){
				SfcTrackingService.trackAnalyticsAction('Exit Intent Modal', 'Secondary Click', this.$store.state.bestPlansExitModalContent.version, 0)
			},

			trackDownloadFamilyGuide(eventDescription, additionalInformation = false) {
				SfcTrackingService.trackAction(eventDescription, "Modal", "2", additionalInformation)
			},

			validateForm() {

				if (this.validateOnChange) {

					this.emailError = false
					this.stateOfResidenceError = false
					this.typeOfUserError = false
					this.emailErrorMessage = ""
					this.stateOfResidenceErrorMessage = ""
					this.typeOfUserErrorMessage = ""

					const emailRegex = /^(([^<>()\[\]\\.,;:\s@“]+(\.[^<>()\[\]\\.,;:\s@“]+)*)|(“.+“))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

					if (!emailRegex.test(this.email)) {
						this.emailError = true
						this.emailErrorMessage = "Please enter a valid email"
					}

					if (!this.stateOfResidence || this.stateOfResidence == "") {
						this.stateOfResidenceError = true
						this.stateOfResidenceErrorMessage = "Please select one"
					}
					if (!this.typeOfUser || this.typeOfUser == "") {
						this.typeOfUserError = true
						this.typeOfUserErrorMessage = "Please select one"
					}
					return !(this.stateOfResidenceError || this.typeOfUserError || this.emailError)
				}
			},

			submitDownloadGuide(clickEvent) {
				this.validateOnChange = true
				if (this.validateForm()) {
					this.downloadGuide()
					this.trackClick()
					this.emailCaptureScreen = 2
				} else {
					clickEvent.preventDefault()
				}
			},


			async submitEmail(typeOfUser, stateId) {
				SfcTrackingService.trackAction('Join email list')
				const params = {
					email: this.email,
					email_capture_source: 'exit-intent',
					signup_source: 'newsletter',
					campaign: 'newsletters',
					consumer_newsletter:'Yes',
					action: 'subscribe',
					from_app: 'spa2',
					mode: 'ajax',
					state_id: stateId || null,
					user_type: typeOfUser || null
				}
				this.emailSuccess = true
				try{
					await this.$httpService.post(`${this.$store.state.config.sfcHost}/mailchimp/mailchimp-api.php`, params, false)

				} catch (e){
					console.error(e)
				}
			},

			async downloadGuide() {
				this.trackDownloadFamilyGuide('Email Capture - Download Family Guide')
				this.emailCaptureScreen = 2
			},

		}

	}
</script>
